export const enMessages = {
  nav: {
    home: "Home",
    about: "About",
    projects: "Projects",
    blog: "Blog",
    cv: "CV",
    contact: "Contact",
  },
  common: {
    language: "Language",
    viewProjects: "View Projects",
    getInTouch: "Get In Touch",
    downloadCv: "Download CV",
  },
  home: {
    heroGreetingDefault: "// Welcome to my portfolio",
    scroll: "SCROLL",
    stats: {
      openSourceRepos: "Open-source Repos",
      monthsOfExperience: "Months of Experience",
      githubStars: "GitHub Stars",
      commits: "Commits",
      projects: "Projects",
      technologies: "Technologies",
      productionCommits: "Production Commits",
    },
    experienceTitle: "Work Experience",
    experienceSubtitle: "My professional journey so far",
    techStackTitle: "Tech Stack",
    techStackSubtitle: "Technologies I work with daily",
    featuredProjectsTitle: "Featured Projects",
    featuredProjectsSubtitle: "Some of my recent work",
    featuredProjectsCta: "View all projects",
    ctaTitle: "Let's Work Together",
    ctaSubtitle: "Interested in collaborating? I'm always open to new projects and opportunities.",
    ctaButton: "Get In Touch",
    musicPlayer: {
      showPlaylist: "Song list",
      hidePlaylist: "Hide playlist",
      lyricsTitle: "Lyrics",
      noLyrics: "No lyrics yet. Add in Admin → Music.",
      expand: "Show lyrics & playlist",
      collapse: "Collapse",
      shuffle: "Shuffle",
      repeat: {
        off: "No repeat",
        one: "Repeat one",
        all: "Repeat all",
      },
      prev: "Previous",
      next: "Next",
      play: "Play",
      pause: "Pause",
      progress: "Playback progress. Click to seek.",
      volume: "Volume",
    },
  },
  about: {
    title: "About Me",
    skillsTitle: "Skills & Expertise",
    experienceTitle: "Work Experience",
    educationTitle: "Education",
    certificatesTitle: "Certificates",
    interestsTitle: "Interests",
    githubActivityTitle: "GitHub Activity",
    githubActivitySubtitle:
      "A realistic snapshot of my commit rhythm, highlighted repositories, and the languages I use most often on GitHub.",
  },
  admin: {
    dashboard: "Dashboard",
    profile: "Profile",
    projects: "Projects",
    experiences: "Experiences",
    education: "Education",
    skills: "Skills",
    certificates: "Certificates",
    music: "Music",
    blog: "Blog",
    messages: "Messages",
    logout: "Logout",
    actions: {
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
    },
    dashboardPage: {
      title: "Dashboard",
      cards: {
        profileLabel: "Profile",
        profileSub: "Settings",
        projectsLabel: "Projects",
        projectsSub: "items",
        experiencesLabel: "Experiences",
        experiencesSub: "entries",
        educationLabel: "Education",
        educationSub: "entries",
        skillsLabel: "Skills",
        skillsSub: "skills",
        certificatesLabel: "Certificates",
        certificatesSub: "certs",
        musicLabel: "Music",
        musicSub: "songs",
        blogLabel: "Blog Posts",
        blogSub: "posts",
        messagesLabel: "Messages",
        messagesSub: "messages",
        messagesUnreadSuffix: "unread",
      },
    },
    messagesPage: {
      title: "Contact Messages",
      empty: "No messages yet.",
      markRead: "Mark as read",
      markUnread: "Mark as unread",
    },
    login: {
      title: "Admin Login",
      email: "Email",
      password: "Password",
      loading: "Signing in...",
      submit: "Sign in",
      backToHome: "← Back to home",
    },
    projectsPage: {
      title: "Manage Projects",
      formTitleAdd: "Add Project",
      formTitleEdit: "Edit Project",
      deleteConfirm: "Delete this project?",
      table: {
        title: "Title",
        tech: "Tech",
        featured: "Featured",
      },
      submitAdd: "Add",
      submitUpdate: "Update",
    },
    experiencesPage: {
      title: "Manage Experiences",
      formTitleAdd: "Add Experience",
      formTitleEdit: "Edit Experience",
      deleteConfirm: "Delete this experience?",
      badgeCurrent: "Current",
      badgePresent: "Present",
      submitAdd: "Add",
      submitUpdate: "Update",
    },
    educationPage: {
      title: "Manage Education",
      formTitleAdd: "Add Education",
      formTitleEdit: "Edit Education",
      deleteConfirm: "Delete this education entry?",
      submitAdd: "Add",
      submitUpdate: "Update",
    },
    skillsPage: {
      title: "Manage Skills",
      formTitleAdd: "Add Skill",
      formTitleEdit: "Edit Skill",
      deleteConfirm: "Delete this skill?",
      submitAdd: "Add",
      submitUpdate: "Update",
    },
    certificatesPage: {
      title: "Manage Certificates",
      formTitleAdd: "Add Certificate",
      formTitleEdit: "Edit Certificate",
      deleteConfirm: "Delete this certificate?",
      submitAdd: "Add",
      submitUpdate: "Update",
      previewAlt: "Preview",
    },
    musicPage: {
      title: "Manage Music",
      formTitleAdd: "Add Song",
      formTitleEdit: "Edit Song",
      deleteConfirm: "Delete this song?",
      submitAdd: "Add",
      submitUpdate: "Update",
      empty: "No songs yet.",
      titleLabel: "Title",
      titlePlaceholder: "Song title",
      artistLabel: "Artist",
      artistPlaceholder: "Artist name",
      coverLabel: "Cover image",
      audioLabel: "Audio file (MP3/MP4)",
      audioHint: "Auto-extract title, artist, cover art, and duration from file metadata.",
      lyricsLabel: "Lyrics (LRC)",
      lyricsPlaceholder: "[00:12.50] First line...\n[00:18.30] Next line...",
      durationLabel: "Duration (seconds)",
      sortLabel: "Sort order",
      audioSizeWarning: "File is large (>15MB) and may load slowly. Continue uploading?",
      table: {
        title: "Song",
        artist: "Artist",
      },
    },
    blogPage: {
      title: "Manage Blog",
      formTitleAdd: "Add Post",
      formTitleEdit: "Edit Post",
      deleteConfirm: "Delete this post?",
      statusPublished: "Published",
      statusDraft: "Draft",
      submitAdd: "Add",
      submitUpdate: "Update",
    },
    profilePage: {
      title: "Profile Settings",
      saved: "✅ Profile saved!",
      syncing: "⏳ Syncing with GitHub...",
      syncSuccess: "✅ GitHub stats synced!",
      syncFailed: "❌ Sync failed.",
      errorPrefix: "❌ Error: ",
      alerts: {
        githubUrlMissing: "Please enter a GitHub URL first.",
        githubUrlInvalid: "Invalid GitHub URL.",
      },
      syncButton: "🔄 Sync GitHub Stats",
      submitSaving: "Saving...",
      submitDefault: "Save Profile",
    },
  },
} as const;

